class Modal {
  constructor() {
    this.settings = {
      modalOpenSelector: '.js--modal-open',
      modalCloseSelector: '.button-exit, .continue',
      modal: '.modal',
      body: 'body',
    };
    this.initListeners();
  }

  initListeners() {
    const modalOpenSelector = $(this.settings.modalOpenSelector);
    const modalCloseSelector = $(this.settings.modalCloseSelector);
    const $this = this;
    modalOpenSelector.on({
      click(e) {
        e.preventDefault();
        $this.prepareModalData(this);
      },
    });
    modalCloseSelector.on({
      click(e) {
        e.preventDefault();
        $this.clearModalBeforeClose(this);
      },
    });
  }

  prepareModalData(element) {
    const $element = $(element);
    const videoUrl = $element.attr('data-video') ? $element.attr('data-video') : false;
    const modal = $(`#${$element.attr('data-target')}`);
    if (videoUrl && modal) {
      modal.find('.modal__body').html(`<div class="embed-responsive embed-responsive-16by9"> 
        <iframe src="${videoUrl}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen />
        </div>`);
    }
    this.openModal(modal);
  }

  openModal(modal) {
    const $body = $(this.settings.body);
    if (modal.hasClass('hidden')) {
      modal.removeClass('hidden').addClass('opening');
      setTimeout(() => {
        modal.removeClass('opening').addClass('open');
        $body.addClass('modal-open');
      }, 50);
    }
  }

  closeModal(modal) {
    const $body = $(this.settings.body);
    if (modal.hasClass('open')) {
      modal.removeClass('open').addClass('hiding');
      setTimeout(() => {
        modal.removeClass('hiding').addClass('hidden');
        $body.removeClass('modal-open');
      }, 500);
    }
  }

  clearModalBeforeClose(element) {
    const $element = $(element);
    const modal = $(`#${$element.attr('data-dismiss')}`);
    if (modal.find('iframe').length && !modal.hasClass('modal-wishlist')) {
      modal.find('.modal__body').html(`<div class="embed-responsive embed-responsive-16by9"> 
        <iframe src="" />
        </div>`);
    }
    this.closeModal(modal);
  }
}

export default Modal;
